import { render } from "./CategoryChooser.vue?vue&type=template&id=1773260b&scoped=true"
import script from "./CategoryChooser.vue?vue&type=script&lang=js"
export * from "./CategoryChooser.vue?vue&type=script&lang=js"

import "./CategoryChooser.vue?vue&type=style&index=0&id=1773260b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1773260b"

export default script